import { inRange } from './maths';

export const orange = 'rgb(252 82 0)';
export const green = 'rgb(54 197 151)';
export const blue = 'rgb(1 104 255)';
export const black = 'rgb(31 31 33)';
export const red = 'rgb(255 0 0)';
export const yellow = 'rgb(255 230 0)';
export const grey = 'rgb(136 136 136)';

// colors from here: https://www.schemecolor.com/red-orange-green-gradient.php
export const colors = [
  '#69B34C',
  '#ACB334',
  '#FAB733',
  '#FF8E15',
  '#FF4E11',
  '#FF0D0D',
];

const maxSufferScore = 300;
const nbColors = colors.length;
const interval = maxSufferScore / nbColors;

export const ranges = colors.map((_color, index) => [
  index * interval,
  (index + 1) * interval,
]);

export const getSufferScoreColor = (score: number) => {
  let color = black;
  for (let i = 0; i < ranges.length; i++) {
    if (inRange(score, ranges[i][0], ranges[i][1])) {
      color = colors[i];
    }
  }

  return color;
};

export const titleStyle = {
  fontSize: '16px',
  fill: 'rgb(51, 51, 51)',
};

export const meanLineStyle = {
  type: 'line',
  marker: {
    enabled: false,
  },
  dashStyle: 'dot',
  enableMouseTracking: false,
};

export const colorObject = {
  running: green,
  cycling: orange,
  swimming: blue,
};
